module.exports = __webpack_public_path__ + "img/premium-satin_thumbnail.d35a90a8.jpg";